import React from 'react'
import { capitalize } from 'lodash'

import Icon from '~/truck/icon'
import { loginProviders } from '~/utils/constants'

import { Button } from './elements'
import GoogleIcon from './google-icon'

const providerOptions = {
  [loginProviders.FACEBOOK]: {
    bgColor: '#4267b2',
    icon: <Icon size="lg" type="facebook" />,
  },
  [loginProviders.GOOGLE]: {
    bgColor: '#4285F4',
    icon: <GoogleIcon />,
  },
}

const SocialLoginButton = props => {
  const { provider, ...rest } = props

  const options = providerOptions[provider]

  return (
    <Button {...rest} bgColor={options.bgColor}>
      {options.icon}
      <span>{`Continuar con ${capitalize(provider)}`}</span>
    </Button>
  )
}

export default SocialLoginButton
